export { default as LtiToolRegistration } from './component/LtiToolRegistration';
export const LtiToolRegistrationDynamic = () => import('./component/LtiToolRegistration');

export { AdditionalSettings } from './component/AdditionalSettings';
export const AdditionalSettingsDynamic = () => import('./component/AdditionalSettings/AdditionalSettings');

export { default as useGetPlatformData } from './hooks/useGetPlatformData';
